import { render, staticRenderFns } from "./memberMulGrade.vue?vue&type=template&id=9812a926&scoped=true&"
import script from "./memberMulGrade.vue?vue&type=script&lang=js&"
export * from "./memberMulGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9812a926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9812a926')) {
      api.createRecord('9812a926', component.options)
    } else {
      api.reload('9812a926', component.options)
    }
    module.hot.accept("./memberMulGrade.vue?vue&type=template&id=9812a926&scoped=true&", function () {
      api.rerender('9812a926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberManage/memberMulGrade.vue"
export default component.exports